import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import UserInfoNoAccess from 'components/NoAccessAcademy/UserInfoNoAccess/UserInfoNoAccess';
import CodeSection from 'components/NoAccessAcademy/CodeSection/CodeSection';
import { academyDataActions } from '../../store/academy-slice';

import classes from './NoAccessAcademy.module.css';

const NoAccessAcademy = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      academyDataActions.showBanner({
        showBanner: true
      })
    );
  }, []);
  const dataUser = useSelector(state => state.userInfo);

  return (
    <section className={classes.noAccessContainer}>
      {dataUser.data.nombre && (
        <div className={classes.infoContainer}>
          <UserInfoNoAccess dataUser={dataUser.data} />
          <CodeSection />
        </div>
      )}
    </section>
  );
};

export default NoAccessAcademy;
